/**
 * Human-readable ASCII for a hex EPC — but ONLY when the whole tag decodes to
 * printable ASCII (e.g. "545053303030303036353131" -> "TPS000006511"). Many
 * tags are EPC-96 / binary (e.g. "E28069132000001001001001") and decoding
 * those yields garbage, so those return null and callers should show the hex
 * alone. Odd-length or non-hex input also returns null.
 */
export function epcToAscii(hex: string | null | undefined): string | null {
  if (!hex || hex.length % 2 !== 0) return null;
  let ascii = '';
  for (let i = 0; i < hex.length; i += 2) {
    const code = parseInt(hex.substring(i, i + 2), 16);
    if (Number.isNaN(code) || code < 32 || code > 126) return null;
    ascii += String.fromCharCode(code);
  }
  return ascii;
}

/**
 * What a person should read for a tag that comes with both of its forms: the
 * registered EPC id and the raw value as the reader captured it.
 *
 * The id wins. It is the key of the `epc` table and what every other screen
 * shows, and for TOCA it is already the printed "TPS000006511". The raw value
 * is only a fallback: for TOCA it is the hex the handheld read
 * ("545053303030303036353131"), which nobody on the floor can match against
 * a pallet, so it is decoded to ASCII when it can be.
 */
export function epcLabel(epcId: string | null | undefined, raw?: string | null): string {
  if (epcId?.trim()) return epcId.trim();
  if (!raw) return '—';
  return epcToAscii(raw) ?? raw;
}
